import {createPortal} from "react-dom";
import {useEffect} from "react";

const Portal = ({children}) => {

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden"; // запретить прокрутку

    return () => {
      document.body.style.overflow = originalOverflow; // восстановить при размонтировании
    };
  }, []);

  const portalRoot = document.getElementById("portal-root");
  if (!portalRoot) return null;

  return createPortal(children, portalRoot);
};

export default Portal;